import React, { ComponentProps } from "react";
import { Route, withRouter, RouteComponentProps } from "react-router-dom";

import { fomatParentPath } from "../../utils";
import { MobRule } from "../../lib";

function Rule(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route
      weId={`${props.weId || ""}_y1jtw3`}
      exact
      path={`${parentPath}/mobile/uk/recommend/rule`}
    >
      {<MobRule weId={`${props.weId || ''}_l0yjny`} />}
    </Route>
  );
}

export default withRouter(Rule);
